import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import Selecto from 'react-selecto';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import moment from 'moment';
import { makeStyles } from '@material-ui/styles';
import { Box, Typography } from '@material-ui/core';
import './style.css';

import { PreferTimeContext } from '../../../services/prefer-time/prefer-time.context';
import { Cell } from './Cell';


const useStyles = makeStyles((theme) => {
  return {
    root: {
      height: '60vh',
      marginBottom: 24,
    },
    header: {
      backgroundColor: '#f7f7f7',
      padding: 0,
    },
    side: {
      backgroundColor: '#f7f7f7',
      borderRight: 'solid 1px #e0e0e0',
      padding: 0,
    },
    rows: {
      height: 45,
    },
    time: {
      textAlign: 'center',
      borderBottom: 'none !important',
      position: 'relative',
    },
    spanTime: {
      top: 0,
      left: '50%',
      transform: 'translate(-50%, -50%)',
      position: 'absolute',
      fontSize: 10,
      color: '#70757a',
      display: 'block',
      backgroundColor: '#fff',
    },
  };
});

export const TimeTable = () => {
  const classes = useStyles();
  const scrollerRef = useRef(null);
  const days = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];

  const { states, functions } = useContext(PreferTimeContext);
  const { preferTime, refreshing } = states;
  const { isExist, onSelectEnd } = functions;

  const [scrollOptions, setScrollOptions] = useState();
  const [rows, setRows] = useState([]);

  useMemo(() => {
    let row = [];
    let date = new Date();
    let result = (data) => moment(data).format('H');

    for (let i = 0; i < 24; i++) {
      date.setHours(i);
      row.push(result(date));
    }
    setRows(row);
  }, []);

  const selected = (day, hour) => !!isExist(day, parseInt(hour, 10));

  const Headers = () =>
    days.map((day, index) => (
      <TableCell key={index} align='center' className={classes.column}>
        {day}
      </TableCell>
    ));

  const WeekDays = ({ hour }) => {
    return days.map((day, i) =>
      !preferTime ? (
        <Cell hour={hour} weekDay={day} key={`${day}-${hour}`} />
      ) : (
        <Cell
          hour={hour}
          weekDay={day}
          key={`${day}-${hour}`}
          isSelected={selected(day, hour)}
        />
      )
    );
  };

  useEffect(() => {
    setScrollOptions({
      container: scrollerRef.current,
      throttleTime: 0,
      threshold: 0,
    });
  }, [preferTime]);

  return (
    <Box>
      <TableContainer className={classes.root} ref={scrollerRef}>
        <Selecto
          dragContainer={'.elements'}
          selectableTargets={['.selecto-area .cube']}
          selectByClick={true}
          selectFromInside={true}
          continueSelect={true}
          scrollOptions={scrollOptions}
          hitRate={0}
          ratio={0}
          onScroll={(e) => {
            scrollerRef.current.scrollBy(
              e.direction[0] * 20,
              e.direction[1] * 20
            );
          }}
          onSelectEnd={!refreshing && onSelectEnd}
        />
        <Table
          id='timeTable'
          stickyHeader
          size='small'
          aria-label='sticky table'
        >
          <TableHead className={classes.header}>
            <TableRow>
              <TableCell />
              <Headers />
            </TableRow>
          </TableHead>

          <TableBody className='elements scroll selecto-area' id='selecto1'>
            {rows &&
              rows.length > 0 &&
              rows.map((hour, i) => (
                <TableRow className={classes.rows} tabIndex={-1} key={i}>
                  <TableCell className={classes.time}>
                    <Box className={classes.spanTime}>
                      <Typography variant='caption' style={{ marginRight: 2 }}>
                        {hour}
                      </Typography>
                    </Box>
                  </TableCell>

                  <WeekDays hour={hour} />
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
